import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  getUserTransactionsAXN,
  filterReferenceNumberAXN,
  getUserPIIDataAXN,
} from '../../actions/transactionHistory/transactionHistoryActions';
import { setAlertAXN } from '../../actions/alert/alertActions';

// VALIDATIONS
import isEmptyVAL from '../../validations/checks/isEmptyVAL';

// UTILITIES
import { transUTL } from '../../utils/transUTL';
import loggerUTL from '../../utils/loggerUTL';
import { proxyAPI } from '../../api/init';
import { loadingToggleAXN } from '../../actions/loading/loadingAction';

// LOGO
import logoBase64 from '../../actions/transactionHistory/helpers/logoB64';

const EToroTransactions = ({ authRXS, loadingToggleAXN, history }) => {
  const [transSTH, setTransSTH] = useState({
    eToroTransactions: [],
    searchID: '',
    filtered: [],
  });

  useEffect(() => {
    if (
      authRXS.user.name === 'eToro_WebProd' ||
      authRXS.user.name === 'Mike_Doran_dz' ||
      authRXS.user.isAdmin
    ) {
    } else {
      history.push('/dashboard');
    }

    var config = {
      headers: {
        proxy_url: 'https://www.dropbox.com/s/346n1fyfw2sq5qj/eToro.json?dl=1',
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    };

    loadingToggleAXN(true);
    proxyAPI
      .get('/proxy', config)
      .then((res) => {
        const data = res.data.data;
        loadingToggleAXN(false);
        setTransSTH({
          ...transSTH,
          eToroTransactions: data,
          filtered: data.slice(0, 50),
        });
      })
      .catch((err) => {
        loadingToggleAXN(false);
        loggerUTL(err);
      });
    // eslint-disable-next-line
  }, []);

  const filterNames = (inputValue) => {
    const { eToroTransactions } = transSTH;

    setTransSTH({
      ...transSTH,
      searchID: inputValue,
      filtered: eToroTransactions
        .filter(
          (item) =>
            item.DZReference.includes(inputValue) ||
            item.clientReference.includes(inputValue)
        )
        .slice(0, 50),
    });
  };

  const getValueInput = (evt) => {
    const inputValue = evt.target.value;
    // setTransSTH({ ...transSTH, searchID: inputValue });
    filterNames(inputValue);
  };

  return (
    <div className="trans-history common-form">
      <header className="header-primary">
        <h2>eToro transactions</h2>
      </header>
      <div className="common-form__body">
        {/* FILTERS */}
        <div className="trans-history__filters">
          <p className="trans-history__filter-count">
            {transSTH.eToroTransactions.length === 1
              ? `${transSTH.eToroTransactions.length} ${transUTL(
                'translateTransactionHistory.search'
              )}`
              : `${transSTH.eToroTransactions.length} ${transUTL(
                'translateTransactionHistory.searches'
              )}`}
          </p>

          <div className="trans-history__filter-input">
            <div className="trans-history__div">
              <input
                type="text"
                name="searchID"
                value={transSTH.searchID}
                placeholder={transUTL(
                  'translatePlaceholder.others.sortByRefNo'
                )}
                onChange={getValueInput}
              />
              <img src={logoBase64} alt="Logo" />
            </div>
          </div>
        </div>
        {/* HISTORY CARDS */}
        {transSTH.filtered.map((history, index) => {
          let countryName = '';

          if (
            !isEmptyVAL(history.philippineCredit) ||
            !isEmptyVAL(history.philippineResidential)
          ) {
            countryName = 'translateCountryNames.philippines';
          }
          if (!isEmptyVAL(history.chinaID) || !isEmptyVAL(history.chinaPhone)) {
            countryName = 'translateCountryNames.china';
          }
          if (
            !isEmptyVAL(history.malaysiaCredit) ||
            !isEmptyVAL(history.malaysiaID)
          ) {
            countryName = 'translateCountryNames.malaysia';
          }
          if (
            !isEmptyVAL(history.vietnamID) ||
            !isEmptyVAL(history.vietnamSS)
          ) {
            countryName = 'translateCountryNames.vietnam';
          }
          if (!isEmptyVAL(history.hongKongID)) {
            countryName = 'translateCountryNames.hongkong';
          }

          return (
            <div
              key={index}
              className={
                true
                  ? 'trans-history__transaction trans-history__border-success'
                  : 'trans-history__transaction trans-history__border-error'
              }
            >
              <div className="trans-history__availability">
                {true ? (
                  <span className="material-icons icon-size trans-history__icon-success">
                    check_circle
                  </span>
                ) : (
                    <span className="material-icons icon-size trans-history__icon-error">
                      cancel
                    </span>
                  )}
              </div>

              <div className="trans-history__body">
                <header className="trans-history__header">
                  <h4>{transUTL(countryName)}</h4>
                </header>

                <p>
                  {transUTL(`translateTransactionHistory.reportingRef`)}{' '}
                  {!isEmptyVAL(history.KMSReference) && history.KMSReference}
                  {!isEmptyVAL(history.DZReference) && history.DZReference}
                </p>

                <p>
                  {transUTL(`translateTransactionHistory.clientRef`)}{' '}
                  {isEmptyVAL(history.clientReference)
                    ? transUTL(`translateReuse.na`)
                    : history.clientReference}
                </p>

                {history.philippineCredit && (
                  <p>
                    Philippine Credit:{' '}
                    {JSON.stringify(history.philippineCredit)}
                  </p>
                )}
                {history.philippineResidential && (
                  <p>
                    Philippine Residential:{' '}
                    {JSON.stringify(history.philippineResidential)}
                  </p>
                )}
                {history.chinaID && (
                  <p>China National ID: {JSON.stringify(history.chinaID)}</p>
                )}
                {history.chinaPhone && (
                  <p>
                    China National Phone: {JSON.stringify(history.chinaPhone)}
                  </p>
                )}
                {history.malaysiaCredit && (
                  <p>
                    Malaysia Credit Bureau:{' '}
                    {JSON.stringify(history.malaysiaCredit)}
                  </p>
                )}
                {history.malaysiaID && (
                  <p>
                    Malaysia National ID: {JSON.stringify(history.malaysiaID)}
                  </p>
                )}
                {history.hongKongID && (
                  <p>
                    Hong Kong National ID: {JSON.stringify(history.hongKongID)}
                  </p>
                )}
                {history.vietnamSS && (
                  <p>
                    Vietnam Social Security: {JSON.stringify(history.vietnamSS)}
                  </p>
                )}
                {history.vietnamID && (
                  <p>
                    Vietnam National ID: {JSON.stringify(history.vietnamID)}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className="single-btn-container">
        <button
          className="btn-primary"
          onClick={() => history.goBack()}
        >
          {transUTL('translateBtn.previousPage')}
        </button>
      </div>
    </div>
  );
};

EToroTransactions.propTypes = {
  authRXS: PropTypes.object.isRequired,
  countryRXS: PropTypes.string.isRequired,
  transHistoryRXS: PropTypes.array.isRequired,
  getUserTransactionsAXN: PropTypes.func.isRequired,
  getUserPIIDataAXN: PropTypes.func.isRequired,
  filterReferenceNumberAXN: PropTypes.func.isRequired,
  setAlertAXN: PropTypes.func.isRequired,
  loadingToggleAXN: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  authRXS: state.authRXS,
  countryRXS: state.countryRXS,
  transHistoryRXS: state.transHistoryRXS,
});

export default connect(mapStateToProps, {
  getUserTransactionsAXN,
  getUserPIIDataAXN,
  filterReferenceNumberAXN,
  setAlertAXN,
  loadingToggleAXN,
})(EToroTransactions);
